// Appels HTTP typés vers /api/members/* — gestion des membres du tenant.

import { api } from "./client";
import type { UUID, UserRole } from "./types";

export type MemberPublic = {
  user_id: UUID;
  email: string;
  full_name: string;
  role: UserRole;
  is_active: boolean;
  joined_at: string; // ISO
  last_login_at: string | null;
};

export type UpdateMemberRolePayload = {
  role: UserRole;
};

export const membersApi = {
  list: () => api.get<MemberPublic[]>("/api/members"),

  updateRole: (userId: UUID, payload: UpdateMemberRolePayload) =>
    api.patch<MemberPublic>(`/api/members/${userId}`, payload),

  remove: (userId: UUID) => api.delete<void>(`/api/members/${userId}`),
};
